<script context="module">
  import PageBody from "$lib/components/Page/PageBody.svelte";
  import isPreviewBuild from "$lib/utilities/isPreviewBuild";
</script>

<script>
  import { setContext } from "svelte";

  import { Button } from "@ObamaFoundation/of-design-system";

  import Seo from "$lib/components/SEO.svelte";
  import { onMount } from "svelte";
  import {
    initializeContentfulPreview,
    livePreviewSubscribe
  } from "$lib/utilities/live-Preview.js";

  export let data;

  const isPreview = isPreviewBuild();
  const spaceId = import.meta.env.VITE_CONTENTFUL_SPACE_ID;
  const environmentId = data.pageEntry.sys.environment.sys.id;
  const entryId = data.pageEntry.sys.id;
  const previewEntryURL = `https://app.contentful.com/spaces/${spaceId}/environments/${environmentId}/entries/${entryId}`;
  const virtualSupporters = data.virtualSupportersData;

  setContext("virtualSupporters", virtualSupporters);
  setContext("pageData", {
    fields: {
      relativeUrl: data.pageEntry.fields.relativeUrl,
      theme: data.pageEntry.fields.theme,
      contentTags: data.pageEntry.fields.contentTags,
      legacyPublishDate: data.pageEntry.fields.legacyPublishDate
    }
  });
  setContext("ipls", data.ipls);
  setContext("epls", data.epls);

  const trailingBody = data.pageEntry.fields.trailingBody;

  const setter = (fieldId, newValue) => {
    // Writing it using spread operator should let data be re-assigned and let other properties depending on it to be updated
    // However, making everything reactive to updated data is not an easy task so we decided to punt that task to backlog
    let updatedPageEntry = {
      ...data.pageEntry,
      fields: {
        ...data.pageEntry.fields,
        [fieldId]: newValue
      }
    };
    data = { ...data, pageEntry: updatedPageEntry };
  };

  onMount(async () => {
    await initializeContentfulPreview(isPreview);
    // Subscribe to live preview updates, this will update the pageEntry in the data object
    livePreviewSubscribe(isPreview, data.pageEntry, setter);
  });
</script>

<Seo data={data.pageEntry.fields} currentUrl={data.currentUrl} cookieBanner={data.cookieBanner} />

<PageBody
  body={data.pageEntry.fields.body}
  class="page-body {trailingBody ? '' : 'last-page-element'}"
/>

{#if trailingBody}
  <PageBody body={trailingBody} class="page-body last-page-element" />
{/if}

{#if isPreview}
  <div class="fixed bottom-8 right-8 z-[--stack-level-layer-top]">
    <Button variant="filled" url={previewEntryURL} label="Edit Page" buttonClass="hover:bg-white" />
  </div>
{/if}
